import React, { useRef, useState } from 'react';
import ItemWrap from '../components/item-wrap';
import Icon from '@ant-design/icons/lib/components/Icon';
import ToolItem from '../components/tool-Item';
import useProps from '../../_util/useProps';
import MeasureDistance from './Measure/Distance';
import MeasureArea from './Measure/Area';
import MeasureHeight from './Measure/Height';
let P = {
    measureDistance: MeasureDistance,
    measureArea: MeasureArea,
    measureHeight: MeasureHeight,
};

export const Toolbox = props => {
    const { type } = props;

    let Page = P[type];
    return <Page {...props} />;
};

const ToolBox = props => {
    const { map, TextEnum } = useProps();

    const options = [
        { label: TextEnum.toolMeasureDistanceText, icon: 'icon-ceju', key: 'measureDistance' },
        { label: TextEnum.toolMeasureAreaText, icon: 'icon-mianji', key: 'measureArea' },
        // { label: TextEnum.toolMeasureHeightText, icon: 'icon-mianji', key: 'measureHeight' },
    ];
    const [active, setActive] = useState('');
    const itemRef = useRef();
    const onChange = v => {
        if (!v.key) {
            return;
        }

        const value = active && v.key === active ? '' : v.key;
        itemRef.current.onVisibleChange(false);
        setActive(value);
    };
    const content = (
        <>
            {options &&
                options.length > 0 &&
                options.map(v => {
                    const params = props[v.key];
                    if (params?.show) {
                        return (
                            <ToolItem
                                key={v.label}
                                onClick={() => onChange(v)}
                                label={v.label}
                                icon={v.icon}
                                active={active === v.key || v.active}
                            />
                        );
                    } else {
                        return null;
                    }
                })}
        </>
    );
    return (
        <>
            <ItemWrap content={content} ref={itemRef}>
                <Icon
                    component={() => (
                        <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
                            <path d="M558.933333 535.466667a45.866667 45.866667 0 0 0-6.4-23.466667h-80a42.666667 42.666667 0 0 0-6.4 23.466667A46.08 46.08 0 0 0 512 583.68a47.573333 47.573333 0 0 0 46.933333-48.213333zM605.013333 535.466667a93.013333 93.013333 0 1 1-185.813333 0 83.413333 83.413333 0 0 1 3.2-23.466667H138.026667v262.826667a94.933333 94.933333 0 0 0 1.066666 10.88v41.6a42.666667 42.666667 0 0 0 42.666667 42.666666h661.333333a42.666667 42.666667 0 0 0 42.666667-42.666666V512H601.813333a88.746667 88.746667 0 0 1 3.2 23.466667zM884.906667 334.72v-42.666667a42.666667 42.666667 0 0 0-42.666667-42.666666h-189.866667v-64a32 32 0 0 0-32-32h-217.6a32 32 0 0 0-32 32v64H181.76a42.666667 42.666667 0 0 0-42.666667 42.666666v173.013334h746.666667v-119.68a94.933333 94.933333 0 0 0-0.853333-10.666667z m-277.333334-85.333333h-189.653333v-26.026667a21.333333 21.333333 0 0 1 21.333333-21.333333h146.133334a21.333333 21.333333 0 0 1 21.333333 21.333333z" />
                        </svg>
                    )}
                />
            </ItemWrap>
            {active && (
                <Toolbox
                    map={map}
                    {...(props[active] || {})}
                    type={active}
                    onClose={() => setActive('')}
                />
            )}
        </>
    );
};

ToolBox.defaultProps = {
    measureDistance: { show: true },
    measureArea: { show: true },
};
export default ToolBox;
